module.exports = __webpack_public_path__ + "fa-brands-400.woff?1a575a4138e5f366474f0e7c5bd614a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-brands-400.woff
// module id = 1449
// module chunks = 0